<template>
<div class="design-side art-area">
    <div class="elements-container">
    <template v-for="(userArtDesignFromList, index) in this.uStore.userDesigns[
            store.currentEditingProps.productId
        ].designs[store.currentEditingProps.variantId].imgVariants[store.currentEditingProps.imageToPreview]
            .userArts" :key="index">
        <div :class="store.currentEditingProps.currentPreview == 'userArt' && store.currentEditingProps.currentPreviewIndex == index ? 'element-div ele-div-active' : 'element-div'">
            <div class="ele-title-line">
                <div class="upload-txt-explain">
                    Allowed file types to upload: <b>SVG</b>
                    max file size: <b>10 MB</b>
                    total: <b>$25</b>
                </div>
                <span class="remove-container" @click.stop="delUserArt(index)">
                    <img class="remove-img" src="../../../public/Icons-DeleteBlackIcon.png" />
                </span>
            </div>
           
            <div class="myArts-container">
                <div class="upload-container">
                    <div class="upload-box" @click.stop="triggerFileUpload(index)" @dragover.prevent="onDragOver" @drop.prevent="onFileDrop($event, index)">
                        <!-- Hidden file input -->
                        <input type="file" :ref="'fileInput-' + index" :id="'file-input-hidden-' + index"
                                @change="onFileSelect($event, index)" style="display: none" 
                                accept=".png, .jpg, .jpeg"/>

                        <!-- Show uploaded file name after upload -->
                        <div v-if="uploadedFilesName[index] && !uploadings[index]">

                            <p class="file-name">{{ uploadedFilesName[index] }}</p>
                            <p>Drag a new file to replace or <span @click.stop="triggerFileUpload(index)">Click to
                                    Change</span></p>
                        </div>

                        <!-- Show progress during upload -->
                        <div v-else-if="uploadings[index]" class="upload-progress-container">
                            <div class="progress-bar">
                                <div class="progress" :style="{ width: uploadsProgress[index] + '%' }"></div>
                            </div>
                            <p>{{ uploadsProgress[index] }}%</p>
                            <p>Uploading File...</p>
                            <div class="spinner"></div>
                        </div>

                        <!-- Show placeholder text if no file uploaded -->
                        <div v-else>
                            <img src="/upload.png" alt="Uploaded File" />
                            <p>Click for your new art</p>
                        </div>
                    </div>
                    <div class="gallery-elements" style="border: 0px; padding: 0px;">
                        <div v-for="(userArt, userArtIndex) in store.getAllUserArts()" :key="userArtIndex" @click="changeUserArt(userArt, index)" :class="userArtDesignFromList.userUploadedArtID == userArt.userUploadedArtID ? 'gallery-item gallery-item-active' : 'gallery-item'">
                            <!-- artDesignFromList.artID == art.artID ? 'gallery-item gallery-item-active' :  -->
                            <!-- {{ userArt }} -->
                            <!-- <img :src="userArt.imgB64Content" /> -->
                             <span class="delete-user-art-img" @click.stop="deleteUserArtImg(userArt)">×</span>
                            <img class="user-art-img" :src="`${store.baseURL}/${userArt.relativePath}_original.png`" />
                            <!-- <img style="position: absolute;" :src="store.baseURL + '/' + userArt.relativePath + '_original.png'" /> -->
                        </div>
                    </div>
                    <div class="colors-select-line" style="margin-top: 10px;">
                        <svg class="vertical-line" height="26" width="3">
                            <line x1="0" y1="0" x2="0" y2="26" style="stroke:#E6E6E6;stroke-width:3" />
                        </svg>

                        <span class="change-size-container">
                            <span @click.stop="increaseSize(index)" style="cursor: pointer;">+</span>
                            <span>
                                <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.846 7.83H2.59L1.806 10H0.462L3.99 0.298H5.46L8.974 10H7.63L6.846 7.83ZM6.482 6.794L4.718 1.866L2.954 6.794H6.482ZM14.8126 8.295H11.4686L10.8526 10H9.79659L12.5686 2.377H13.7236L16.4846 10H15.4286L14.8126 8.295ZM14.5266 7.481L13.1406 3.609L11.7546 7.481H14.5266Z" fill="#2D2D2D" />
                                </svg>
                            </span>
                            <span @click.stop="decreaseSize(index)" style="cursor: pointer;">-</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </template>

    </div>
    <span class="btn-add-element" title="Upload new art" style="width: 140px;" @click="addUserArtToDesign()">
        + Upload new art
    </span>
</div>
</template>

<script>
import {
    designerStore
} from "@/stores/designerStore";
import {
    userStore
} from "@/stores/userStore";
// import { ref } from "vue";
// import DSTPreview from "../DSTPreview.vue";
// import SelectColor from "../SelectColor.vue";
export default {
    components: {
        // DSTPreview,
        // SelectColor,

    },
    setup() {
        const store = designerStore();
        const uStore = userStore();
        return {
            store,
            uStore,
        };
    },
    data() {
        return {
            searchArtText: "",
            filterByArtCategories: [],
            selectedButton: [],

            //upload image data
            uploadings: [],
            uploadsProgress: [],
            uploadedFilesName: [], // To store the name of the uploaded file
        }
    },
    props: {
        changeStyleByRef: {
            type: Function,
            required: true
        },
        increaseArtSize: {
            type: Function,
            required: true
        },
        decreaseArtSize: {
            type: Function,
            required: true
        },
        changeArc: {
            type: Function,
            required: true
        },
        resetArc: {
            type: Function,
            required: true
        },
    },

    methods: {
        async addUserArtToDesign() {
            // this.showWindowToUploadUserArt = true;
            this.store.addUserArtToDesign(
                this.store.currentEditingProps.productId,
                this.store.currentEditingProps.variantId,
                this.store.currentEditingProps.imageToPreview
            );
            this.store.currentEditingProps.currentPreviewIndex =
                this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
                .imgVariants[this.store.currentEditingProps.imageToPreview].userArts.length - 1;
            this.store.currentEditingProps.currentPreview = "userArt";
        },
        async changeUserArt(userArt, userArtIndex) {
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                    this.store.currentEditingProps.variantId
                ].imgVariants[this.store.currentEditingProps.imageToPreview].userArts[userArtIndex].userUploadedArtID =
                userArt.userUploadedArtID;

                this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId
            ].imgVariants[this.store.currentEditingProps.imageToPreview].userArts[
                userArtIndex
            ].dragTransform.width = this.store.allUserArts.value[userArt.userUploadedArtID].pixelWidth;
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId
            ].imgVariants[this.store.currentEditingProps.imageToPreview].userArts[
                userArtIndex
            ].dragTransform.height = this.store.allUserArts.value[userArt.userUploadedArtID].pixelHeight;

            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId
            ].imgVariants[this.store.currentEditingProps.imageToPreview].userArts[
                userArtIndex
            ].dragTransform.scale.scaleX = 1;

            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId
            ].imgVariants[this.store.currentEditingProps.imageToPreview].userArts[
                userArtIndex
            ].dragTransform.scale.scaleY = 1;
            await this.changeStyleByRef('userArt');
        },
        delUserArt(index) {
            this.store.delUserArt(
                this.store.currentEditingProps.productId,
                this.store.currentEditingProps.variantId,
                this.store.currentEditingProps.imageToPreview,
                index
            );
            this.store.currentEditingProps.currentPreviewIndex = -1;
            // this.uploadsProgress[index] = null;
            // this.uploadings[index] = null;
            // this.uploadedFilesName[index] = null;
            this.dropUploadsListsIndex(index);
        },
        dropUploadsListsIndex(index) {
            // Update uploadsProgress array
            for (let i = index; i < this.uploadsProgress.length - 1; i++) {
                this.uploadsProgress[i] = this.uploadsProgress[i + 1];
            }
            this.uploadsProgress.pop(); // Remove the last element

            // Update uploadings array
            for (let i = index; i < this.uploadings.length - 1; i++) {
                this.uploadings[i] = this.uploadings[i + 1];
            }
            this.uploadings.pop(); // Remove the last element

            // Update uploadedFilesName array
            for (let i = index; i < this.uploadedFilesName.length - 1; i++) {
                this.uploadedFilesName[i] = this.uploadedFilesName[i + 1];
            }
            this.uploadedFilesName.pop(); // Remove the last element
        },
        //upload image functions
        triggerFileUpload(index) {
            // this.$refs.fileInput-index.click();
            document.getElementById("file-input-hidden-" + index).click();
        },
        onFileSelect(event, index) {
            const file = event.target.files[0];
            if (file) {
                this.uploadFile(file, index);
            }
        },
        onDragOver(event) {
            event.dataTransfer.dropEffect = "copy";
        },
        onFileDrop(event, index) {
            const file = event.dataTransfer.files[0];
            if (file) {
                this.uploadFile(file, index);
            }
        },
        async uploadFile(file, index) {
            this.uploadings[index] = true;
            this.uploadedFilesName[index] = null; // Reset file name during upload
            const totalSize = file.size;
            let uploaded = 0;
            let fakeProgress = 0;

            const interval = setInterval(() => {
                if (fakeProgress < 90) {
                    uploaded += totalSize * 0.03;
                    fakeProgress = parseInt(Math.min((uploaded / totalSize) * 100, 90));
                    this.uploadsProgress[index] = fakeProgress;
                }
                // uploaded += totalSize * 0.05; // Simulate upload progress
                // this.uploadsProgress[index] = parseInt(Math.min((uploaded / totalSize) * 100, 100));

                // if (this.uploadsProgress[index] === 100) {
                //     clearInterval(interval);
                //     setTimeout(() => {
                //         this.uploadings[index] = false;
                //         this.uploadedFilesName[index] = file.name; // Set the uploaded file name
                //     }, 500);
                // }
            }, 200);
            try {
                // Step 1: Convert file to base64
                const base64 = await this.readFileAsBase64(file);

                // Step 2: Call your API function
                await this.store.userUploadArt(base64, index); // Send the base64 string

                clearInterval(interval);
                this.uploadsProgress[index] = 100;

                setTimeout(() => {
                    this.uploadings[index] = false;
                    this.uploadedFilesName[index] = file.name;
                }, 500);
            } catch (error) {
                clearInterval(interval);
                this.uploadings[index] = false;
                this.uploadsProgress[index] = 0;
                console.error("Upload failed:", error);
            }
        },
        readFileAsBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result); // this includes data:...base64,...
                };
                reader.onerror = reject;
                reader.readAsDataURL(file); // You can also use readAsBinaryString or readAsArrayBuffer if needed
            });
        },
        async deleteUserArtImg(userArt) {
            await this.store.deleteUserArtImg(userArt);
        },
        increaseSize(index) {
            this.store.currentEditingProps.currentPreviewIndex = index;
            this.store.currentEditingProps.currentPreview = "userArt";
            this.increaseArtSize(index);
        },
        decreaseSize(index) {
            this.store.currentEditingProps.currentPreviewIndex = index;
            this.store.currentEditingProps.currentPreview = "userArt";
            this.decreaseArtSize(index);
        }
    }
};
</script>

<style scoped>
.design-side {
    height: 334px;
    top: 555px;
    left: 968px;
}

.element-div {
    height: 240px;
    top: 9px;
    border-radius: 12px;
    border: 0.4px solid var(--3, #8A8A8A);
    margin-bottom: 5px;
}

span.ele-title {
    display: flex;
    gap: 10px;
    align-items: center;
}

.art-categories-container {
    overflow-y: auto;
    max-height: 90px;
}

span.art-category-title {
    font-size: 12px;
}

.colors-select-line {
    display: flex;
    gap: 15px;
    margin-top: 10px;
    flex-wrap: wrap;
    align-items: center;
}

/* .colors-select-line>div {
    margin-right: 20px;
} */

.colors-select-line>svg {
    margin-right: 8px;
}

.vertical-line {
    margin-right: 8px;
}

.change-size-container {
    padding-left: 0px;
    border: none;
    display: flex;
    align-items: center;
    gap: 8px;
}

.search-container {
    /* margin-left: 140px; */
    /* margin-left: 160px; */
    /* margin-right: 2%; */
    border: 1px solid #D9D9D9;
    background: #FFFFFF;
    width: 220px;
    height: 32px;
    top: 524px;
    border-radius: 4px;
    margin-right: 10px;
}

.search-container img {
    margin-left: 5px;
    border: 1.2px solid var(--, #2D2D2D);
    width: 13.33px;
    height: 13.33px;
    top: 1.33px;
    left: 1.33px;

}

.ele-input {

    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.41px;
    text-align: left;
    width: 70%;
    height: 16px;
    top: 531px;
    left: 1358px;
    border: none
}

.ele-input::placeholder {
    color: #D2D2D2;
    font-family: Roboto;

}

.ele-input:focus {
    outline: none;
}

.btn-add-element {
    cursor: pointer;
    width: 119px;
    height: 32px;
    top: 720px;
    left: 968px;
    gap: 0px;
    border-radius: 12px;
    background: #72984F12;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.41px;
    text-align: left;
    color: black;
}

.toggle-switch-art {
    display: flex;
    padding: 5px;
    /* width: 80%; */
    align-items: center;
    justify-content: flex-start;
    row-gap: 15px;
    column-gap: 15px;
}

.toggle-switch-art button {
    font-family: Roboto;
    font-size: 12px;
    font-weight: 400;
    line-height: 18.75px;
    text-align: center;
    color: var(--3, #8A8A8A);
    border: none;
    border-radius: 12px;
    cursor: pointer;
}

.toggle-switch-art button.active {
    border-radius: 18px;
    font-family: "Roboto", sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 18.75px;
    letter-spacing: 0%;
    color: #2D2D2D;
    background: #72984F2E;
    padding: 7px 20px;
}

.remove-container {
    margin-right: 2%;
    height: fit-content;
}
.delete-user-art-img {
    z-index: 1;
    position: absolute;
    top: -2px;
    right: 3px;
    cursor: pointer;
}
.user-art-img {
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    padding: 5px;
}
.art-categories-container {
    margin: 20px;
}

.gallery-elements {
    max-height: 25vh;
    position: relative;
    display: flex;
    width: 100%;
    gap: 8px;
    padding: 10px;
    flex-wrap: wrap;
}

.gallery-item {
    background: #EDEDED;
    border-radius: 4px;
    width: 73px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    position: relative;
}

.gallery-item-active {
    border: 1px solid #2D2D2D
}
</style>
<style scoped>
/* < !-- upload image css --> */
.upload-container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
}

.upload-box {
    width: 47%;
    height: 137px;
    border: 1px dashed #8A8A8A;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.3s;
}

.upload-box:hover {
    border-color: #777;
}

.progress-bar {
    width: 80%;
    height: 5px;
    background: #f0f0f0;
    margin-bottom: 10px;
    position: relative;
}

.progress {
    height: 100%;
    background: #4caf50;
    transition: width 0.2s;
}

.spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1s linear infinite;
    display: block;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.file-name {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
}

.upload-txt-explain {
    background: #EFEFEF33;
    padding: 15px;
    /* width: 47%; */
    height: fit-content;
    font-size: 10px;
}

.upload-progress-container {
    display: grid;
    justify-items: center;
}
</style>
